import { logUtil } from 'packages/src'
import { updateTokenIdStripeAction } from 'modules/stripe/redux/actions/update-token-id/index.js'

const CENTS_PER_CURRENCY_UNIT = 100
const CURRENCY = 'usd'

/**
 * @param stripe
 * @param setCanMakePayment
 * @param setPaymentRequest
 * @param productLabel
 * @param amount
 * @param onSubmit
 * @returns {(function(*, *): Promise<void>)|*}
 */
export const initPaymentRequestStripeAction = ({
  stripe,
  setCanMakePayment,
  setPaymentRequest,
  productLabel,
  amount,
  onSubmit
}) => {
  return async (dispatch, getState) => {
    logUtil('initPaymentRequestStripeAction').debug('stripe=', stripe)
    try {
      const propsToPass = {
        country: 'CA',
        currency: CURRENCY,
        total: {
          label: productLabel,
          amount: Math.round(amount * CENTS_PER_CURRENCY_UNIT)
        }
      }

      logUtil('initPaymentRequestStripeAction').debug('propsToPass=', propsToPass)

      const paymentRequest = stripe.paymentRequest(propsToPass)
      logUtil('initPaymentRequestStripeAction').debug('paymentRequest=', paymentRequest)
      if (!paymentRequest) {
        setCanMakePayment(false)
        return
      }

      const handleReceiveToken = (payload) => {
        const {
          token,
          complete
        } = payload

        if (!token) {
          complete('fail')
          return
        }

        const tokenId = token.id
        dispatch(updateTokenIdStripeAction(tokenId))
        onSubmit(tokenId)
        complete('success')
      }

      paymentRequest.on('token', handleReceiveToken)

      const result = await paymentRequest.canMakePayment()

      setPaymentRequest(paymentRequest)
      setCanMakePayment(!!result)

      return result
    } catch (error) {
      logUtil('initPaymentRequestStripeAction').error('error=', error)
      setCanMakePayment(false)
    }
  }
}
